<template>
  <div class="channelRecord">
    <PageNav :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{ $t("Customersmanage.dba") }}</span>
            </div>
          </div>
          <div class="custoMersmanage-container">
            <div class="content" style="padding-top: 0">
              <div class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">
                    {{ $t("Customersmanage.dbb") }}：
                  </span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.range_time"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      @change="handleSelect"
                      v-model="selectForm.channellog_status"
                      clearable
                      filterable
                      class="select-mini"
                      style="width: 150px"
                      :placeholder="$t('Customersmanage.dbc')"
                    >
                      <el-option
                        v-for="item in selectForm.channelStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.frommedia_id"
                      class="select-mini"
                      style="width: 175px"
                      @change="filterFrommedia"
                      :placeholder="$t('Customersmanage.dbd')"
                    >
                      <el-option
                        v-for="item in selectForm.sourceList"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.channel_id"
                      class="select-mini"
                      style="width: 175px"
                      @change="handleSelect"
                      :placeholder="$t('Customersmanage.dbh')"
                    >
                      <el-option
                        v-for="item in selectForm.channelList"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      style="width: 240px"
                      :placeholder="$t('Customersmanage.dbe')"
                      class="input-cont"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    style="margin-right: 0px"
                    @click="handleSelectKeyword()"
                    >{{ $t("Customersmanage.an") }}</el-button
                  >
                </div>
              </div>
              <div class="pl20 pr20">
                <div
                  class="table-list"
                  style="position: relative"
                  ref="auto_height_table"
                >
                  <TableList
                    :list="tableData"
                    :options="optionscaozuo"
                    :columns="columns"
                    :operates="operates"
                    :tableOperate="tableOperate"
                    :tableSort="tableSort"
                    @handleCommandSort="handleCommandSort"
                    @toggleEditableColumn="toggleEditableColumn"
                    @handleSelectionChange="handleSelectionChange"
                    @handleColumnChange="handleColumnChange"
                  ></TableList>
                  <div class="personalInfo-tips">
                    <i class="crmIcon-ysbh"></i>
                    <span>{{ $t("Common.personalInfo_tips") }}</span>
                  </div>
                </div>
                <el-pagination
                  style="margin-top: 20px"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="dataNumber"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 查看单条记录-->
    <SliderBox :showSliderBox="showDetailPop" :sliderWidth="minSliderwidth">
      <div class="silder-contain slider-channel-record">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("views.Customersmanage.channelRecord.5zrpeqo9m740") }}
          </p>
          <el-button
            type="default"
            class="pull-right"
            @click="showDetailPop = false"
          >
            {{ $t("Customersmanage.dbg") }}
          </el-button>
        </div>
        <div class="slider-cont text-1 pop-channel-user">
          <div class="user-header mb10" v-if="rowData">
            <div class="user-header__img">
              <img
                :src="
                  rowData.client_img ||
                    (rowData.client_sex ==
                    $t('views.Customersmanage.channelRecord.5zrpeqo9nq40')
                      ? require('@/assets/images/default-img-man.png')
                      : require('@/assets/images/default-img-women.png'))
                "
                alt=""
              />
            </div>
            <div class="user-header__desc">
              <p class="desc">
                {{ rowData.client_cnname }}
                <img
                  class="ml10 mr10"
                  :src="
                    rowData.client_sex ==
                    $t('views.Customersmanage.channelRecord.5zrpeqo9nq40')
                      ? require('@/assets/images/icon/icon-person-men.png')
                      : require('@/assets/images/icon/icon-person-women.png')
                  "
                  alt=""
                />
                <span v-if="rowData.status == 1" class="tag-normal mr15">
                  {{ $t("Customersmanage.dbf") }}</span
                >
                <span
                  class="tag-status"
                  :class="{
                    'tag-red': rowData.channellog_level == 2,
                    'tag-yellow': rowData.channellog_level == 1,
                    'tag-blue': rowData.channellog_level == 0,
                  }"
                >
                  {{
                    rowData.channellog_level == 2
                      ? $t("views.Customersmanage.channelRecord.5zrpeqo9ny00")
                      : rowData.channellog_level == 1
                      ? $t("views.Customersmanage.channelRecord.5zrpeqo9o340")
                      : $t("views.Customersmanage.channelRecord.5zrpeqo9o7c0")
                  }}
                </span>
              </p>
              <table>
                <tr>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpeqo9ocw0")
                    }}</span
                    >{{ rowData.from_channel_medianame }}
                  </td>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpeqo9ogw0")
                    }}</span
                    >{{ rowData.from_channel_medianame }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpeqo9ol00")
                    }}</span
                    >{{ rowData.to_channel_medianame }}
                  </td>
                  <td>
                    <span>{{$t('views.Customersmanage.channelRecord.5zrpier5rjw0')}}</span>{{ rowData.to_channel_name }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-if="rowData.channellog_status != 0"
              class="notice-tags"
              :class="{
                'notice-success': rowData.channellog_status == 1,
                'notice-fail': rowData.channellog_status == -1,
              }"
            >
              <span>
                {{
                  rowData.channellog_status == 1
                    ? $t("views.Customersmanage.channelRecord.5zrpeqo9op00")
                    : rowData.channellog_status == -1
                    ? $t("views.Customersmanage.channelRecord.5zrpeqo9p7s0")
                    : ""
                }}</span
              >
            </div>
          </div>
          <el-tabs class="channel-view__tabs" v-model="applyActive">
            <el-tab-pane
              :label="$t('views.Customersmanage.channelRecord.5zrpeqo9pks0')"
              name="first"
            >
              <p class="form-small-title h3 mt5">
                {{ $t("views.Customersmanage.channelRecord.5zrpeqo9pks0") }}
              </p>
              <ul class="channel-apply-info" v-if="rowData">
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9pq00")
                  }}</span
                  ><span class="desc">{{ rowData.school_cnname }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9pto0")
                  }}</span
                  ><span class="desc">{{ rowData.client_age }}岁</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9pww0")
                  }}</span
                  ><span class="desc">{{ rowData.family_relation }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9q040")
                  }}</span
                  ><span class="desc">{{ rowData.client_mobile }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9q3c0")
                  }}</span
                  ><span class="desc">{{ rowData.client_createtime }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9q6c0")
                  }}</span
                  ><span class="desc">{{ rowData.client_remark }}</span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane
              :label="$t('views.Customersmanage.channelRecord.5zrpeqo9q9c0')"
              name="second"
            >
              <div class="slider-trackRecord">
                <div class="record-info">
                  <p class="form-small-title h3 mt5">
                    {{ $t("User.s_title7") }}
                  </p>
                  <el-row v-for="(items, index) in trackList" :key="index">
                    <el-col :span="4">
                      <div class="grid-content bg-purple grid-content-img">
                        <img
                          :src="
                            items.marketer_img ||
                              (items.staffer_sex ==
                              $t(
                                'views.Customersmanage.channelRecord.5zrpeqo9nq40'
                              )
                                ? require('@/assets/images/default-img-man.png')
                                : require('@/assets/images/default-img-women.png'))
                          "
                        />
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div class="grid-content bg-purple-light text-1">
                        <p class="clearFloat">
                          {{ items.marketer_name }}
                          <span
                            v-if="items.track_linktype != ''"
                            class="btn-purple font-gray"
                            >{{ items.track_linktype }}</span
                          >
                          <span
                            v-if="items.track_followcont != ''"
                            class="btn-purple font-gray"
                            >{{ items.track_followcont }}</span
                          >
                          <span class="font-gray show-time pull-right">{{
                            items.track_createtime
                          }}</span>
                        </p>
                        <p>
                          {{ $t("User.follow_label2") }}{{ items.object_name }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryClass") }}{{ items.class_cnname }}
                        </p>
                        <p v-if="items.track_followmode == '1'">
                          {{ $t("User.guiDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p
                          v-if="
                            items.track_followuptime &&
                              items.track_followuptime != ''
                          "
                        >
                          {{ $t("User.nextFollowDate")
                          }}{{ items.track_followuptime }}
                        </p>
                        <div class="flex-all">
                          <p>
                            {{ $t("User.followSchool") }}
                            {{ items.school_cnname }}
                          </p>
                          <p
                            v-if="items.track_isreading == '1'"
                            class="text-3 mb10"
                          >
                            {{ items.level_marketer_name }}
                            <span class="font-gray"
                              >{{ $t("User.label_text20")
                              }}{{ items.track_readtime
                              }}{{ $t("User.btn_text4") }}</span
                            >
                          </p>
                        </div>
                        <!-- 回复列表 -->
                        <div
                          v-if="
                            items.replay_info && items.replay_info.length > 0
                          "
                          class="replay-list"
                        >
                          <div
                            v-for="(item1, index1) in items.replay_info"
                            :key="index1"
                            class="communite-replay"
                          >
                            <div class="img mt20 mb10">
                              <img
                                :src="
                                  item1.marketer_img ||
                                    (item1.staffer_sex ==
                                    $t(
                                      'views.Customersmanage.channelRecord.5zrpeqo9nq40'
                                    )
                                      ? require('@/assets/images/default-img-man.png')
                                      : require('@/assets/images/default-img-women.png'))
                                "
                              />
                            </div>
                            <div class="replay-cont">
                              <div class="replay-top mt20 mb10">
                                <span>
                                  {{ item1.marketer_name }}
                                  <span class="font-gray ml5 mr5">{{
                                    $t("User.btn_text6")
                                  }}</span>
                                  {{ items.marketer_name }}
                                </span>
                                <span class="font-gray">{{
                                  item1.replay_createtime
                                }}</span>
                              </div>
                              <p>{{ item1.replay_note }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <p class="no-data" v-if="trackList.length == 0">
                    <i class="crm-wu"></i>
                    {{ $t("User.noFollowRecord") }}
                  </p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label"
                >{{ $t("Customersmanage.dbj") }}
                <em v-if="channelChangeApplyNum > 0" class="tab-num-tips">{{
                  channelChangeApplyNum
                }}</em></span
              >
              <p class="form-small-title h3 mt5">
                {{ $t("Customersmanage.dbj") }}
              </p>
              <div
                v-for="(activity, index) in channelChangeList"
                :key="index"
                class="channel-history"
              >
                <div class="channel-history__title">
                  {{ activity.createtime }}
                </div>
                <div class="channel-history-box">
                  <div class="channel-row">
                    <div class="channel-detail">
                      <div class="channel-detail__content">
                        <p>{{ activity.from_frommedia_name }}</p>
                        <p>{{ activity.from_channel_name }}</p>
                        <p>{{ activity.channellog_client_frompage }}</p>
                      </div>
                      <div class="channel-detail__tips">
                        <img src="@/assets/images/change-icon.png" alt="" />
                        <p>{{ $t("Customersmanage.dbl") }}</p>
                      </div>
                      <div class="channel-detail__content">
                        <p>{{ activity.to_frommedia_name }}</p>
                        <p>{{ activity.to_channel_name }}</p>
                        <p>&nbsp;</p>
                      </div>
                    </div>
                    <div
                      class="channel-status"
                      :class="{
                        'status-success': activity.tracks_title == 1,
                        'status-fail': activity.tracks_title == -1,
                        'status-wait': activity.tracks_title == 0,
                      }"
                    >
                      <span class="dot"></span>
                      {{
                        activity.tracks_title == "0"
                          ? $t("Customersmanage.dbk")
                          : activity.tracks_title == "1"
                          ? $t(
                              "views.Customersmanage.channelRecord.5zrpeqo9op00"
                            )
                          : activity.tracks_title == "-1"
                          ? $t(
                              "views.Customersmanage.channelRecord.5zrpeqo9p7s0"
                            )
                          : ""
                      }}
                    </div>
                  </div>
                  <template v-if="activity.tracks_title == 0">
                    <p class="channel-history__teacher">
                      {{ $t("Customersmanage.dbm") }}：{{
                        activity.staffer_cnname
                      }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbn") }}：
                      {{ activity.channellog_changetime || "--" }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbo") }}：
                      {{ activity.channellog_reason }}
                    </p>
                    <!-- <p
                      v-if="activity.channellog_img"
                      class="channel-history__teacher"
                    >
                      {{$t('views.Customersmanage.channelRecord.5zrpeqo9qd00')}}
                      <span
                        @click="
                          (showImgUrl = activity.channellog_img),
                            (showImgMask = true)
                        "
                        style="color: #20a8d8; cursor: pointer;"
                        >{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</span
                      >
                    </p> -->
                    <p
                      v-if="activity.channellog_imgjson"
                      class="channel-history__teacher"
                    >
                      {{ $t("Customersmanage.dbp") }}：
                      <span
                        @click="
                          (showImgUrlArr = activity.channellog_imgjson),
                            (showImgMask = true),
                            onPreview(activity.channellog_imgjson)
                        "
                        style="color: #20a8d8; cursor: pointer"
                        >{{ $t("Customersmanage.dbr") }}</span
                      >
                    </p>

                    <!-- <div v-if="activity.channellog_imgjson">
                      <el-button type="text" @click="onPreview(activity.channellog_imgjson)">{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</el-button>
                      <el-image-viewer
                        v-if="showViewer"
                        :on-close="closeViewer"
                        :url-list="url"
                        >
                      </el-image-viewer>
                    </div> -->
                  </template>
                  <template v-else>
                    <p class="channel-history__teacher">
                      审核人：{{ activity.astaffer_cnname }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbn") }}：
                      {{ activity.channellog_changetime || "--" }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbo") }}：
                      {{ activity.channellog_note }}
                    </p>
                    <!-- <p
                      v-if="activity.channellog_img"
                      class="channel-history__teacher"
                    >
                      {{$t('views.Customersmanage.channelRecord.5zrpeqo9qd00')}}
                      <span
                        @click="
                          (showImgUrl = activity.channellog_img),
                            (showImgMask = true)
                        "
                        style="color: #20a8d8; cursor: pointer;"
                        >{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</span
                      >
                    </p> -->
                    <p
                      v-if="activity.channellog_imgjson"
                      class="channel-history__teacher"
                    >
                      {{
                        $t("views.Customersmanage.channelRecord.5zrpeqo9qd00")
                      }}
                      <span
                        @click="
                          (showImgUrlArr = activity.channellog_imgjson),
                            (showImgMask = true),
                            onPreview(activity.channellog_imgjson)
                        "
                        style="color: #20a8d8; cursor: pointer"
                        >{{ $t("Customersmanage.dbr") }}</span
                      >
                    </p>

                    <!-- <div v-if="activity.channellog_imgjson">
                      <el-button type="text" @click="onPreview(activity.channellog_imgjson)">{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</el-button>
                      <el-image-viewer
                        v-if="showViewer"
                        :on-close="closeViewer"
                        :url-list="url"
                        >
                      </el-image-viewer>
                    </div> -->
                  </template>
                </div>
              </div>
              <p v-if="channelChangeList.length == '0'" class="no-data">
                <i class="el-icon-document"></i>
                {{ $t("views.Customersmanage.channelRecord.5zrpeqo9qk00") }}
              </p>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </SliderBox>

    <!-- <div @click="showImgMask = false" v-if="showImgMask" class="show-img__mask">
      <img :src="showImgUrl" alt="" />
    </div> -->

    <div id="viewerStyle" v-if="showImgMask">
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="url"
      >
      </el-image-viewer>
    </div>
  </div>
</template>
<script>
import ElImageViewer from "../../../node_modules/element-ui/packages/image/src/image-viewer";
import PageNav from "../../components/Nav/nav.vue";
import SliderBox from "../../components/SliderBox";
import TableList from "../../components/Table/table.vue";
import channelRecordRequest from "./channelRecord.js";
export default {
  name: "CustoMersmanage-custoMersmanage",
  data() {
    return {
      showViewer: false, // 显示查看器
      url: [],
      // srcList: [],
      showImgUrlArr: [],
      showImgMask: false,
      showImgUrl: "",
      openMenu: ["3"],
      showSliderBox: false,
      showSliderBoxSee: false,
      settingVisible: false,
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      data: [],
      loading: false,
      customerId: "", // 客户id

      // 查看
      rowData: null,
      showDetailPop: false,
      applyActive: "first",
      channelChangeList: [],
      channelChangeApplyNum: 0,
      trackList: [],

      //用户基本信息
      UserInformation: [],
      ActivityOption: [],
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      //筛选条件
      selectForm: {
        channellog_status: "",
        channelStatusList: [
          {
            label: this.$t("views.Customersmanage.channelRecord.5zrpeqo9qp40"),
            value: "0",
          },
          {
            label: this.$t("views.Customersmanage.channelRecord.5zrpeqo9qtw0"),
            value: "1",
          },
          {
            label: this.$t("views.Customersmanage.channelRecord.5zrpeqo9qx00"),
            value: "-1",
          },
        ],

        sourceList: [], //选择渠道类型-下拉数据
        frommedia_name: "",
        frommedia_id: "",
        channelList: [], //选择渠道明细-下拉数据
        channel_id: "",
        range_time: "", //创建时间
        keyword: "",
      },

      // 招生渠道类型
      input: "",
      select: "",
      imageUrl: "",
      sliderWidth: "700px", //侧边栏宽度
      minSliderwidth: "620px",
      activeName: "first",
      buttonHide: false,
      //多条线索信息
      MultipleClues: [],
      options: [],
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 100,
        label: this.$t("Customersmanage.bss"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("views.Customersmanage.channelRecord.5zrpeqo9m740"),
            type: "text",
            show: true,
            plain: true,
            Customfloow: true,
            disabled: false,
            method: (index, row) => {
              console.warn(index);
              console.warn(row);
              this.rowData = row;
              this.getChannelTrack();
              this.clientOneTrackApi();
              this.showDetailPop = true;
            },
          },
        ],
      }, // 列操作按钮
      tableOperate: {
        label: "",
        operate: true,
        align: "center",
        fixed: "right",
      },
      // 排序方式
      tableSort: {
        label: "",
        operate: true,
        align: "center",
        fixed: "right",
        sortOption: [],
      },

      notreadnum: 0, //未读提醒人数
      isShowListTips: true, //是否显示名单更新
    };
  },
  components: {
    PageNav,
    SliderBox,
    TableList,
    ElImageViewer,
  },
  updated() {},
  watch: {
    showDetailPop(n) {
      if (!n) {
        this.applyActive = "first";
      }
    },

    applyActive(n) {
      if (n == "third") {
        this.getChannelTrack();
      } else if (n == "second") {
        this.clientOneTrackApi();
      }
    },
  },
  created() {
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";

    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.getChannellogList();
    this.getSourceApi();
    this.getChannel();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 65
        );
      }
    });
  },
  methods: {
    // 点击按钮预览图片
    onPreview(img) {
      console.warn(img);
      this.url = img;
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    handleApply() {
      (() => {})("ok");
    },
    filterFrommedia() {
      this.selectForm.channel_id = "";
      this.selectForm.sourceList.forEach((e) => {
        if (e.frommedia_id == this.selectForm.frommedia_id) {
          this.selectForm.frommedia_name = e.frommedia_name;
        }
      });
      if (!this.selectForm.frommedia_id) {
        this.selectForm.frommedia_name = "";
      }
      this.getChannel();
      this.handleSelect();
    },
    clientOneTrackApi() {
      channelRecordRequest
        .clientOneTrackApi({
          client_id: this.rowData.client_id,
        })
        .then((res) => {
          this.trackList = [];
          const { data } = res.data;
          data.list.forEach((item) => {
            var str = item.track_followmode_name;
            this.trackList.push(
              Object.assign({}, item, {
                track_followcont: str,
                isClickReply: false,
                replay_note: "",
              })
            );
          });
        });
    },
    // 渠道变更记录
    getChannelTrack() {
      channelRecordRequest
        .getChannelTrack({
          client_id: this.rowData.client_id,
          channellog_id: this.rowData.channellog_id,
        })
        .then((res) => {
          console.warn(res);
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.channelChangeList = data.data;
            this.channelChangeApplyNum = parseInt(data.num) || 0;
            // this.srcList = data.data[0].channellog_imgjson;
            // (() => {})(this.srcList);
          } else {
            this.channelChangeList = [];
          }
        });
    },
    getSourceApi() {
      this.$http.getSource({}).then((res) => {
        (() => {})(res);
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.selectForm.sourceList = data.list;
        } else {
          this.selectForm.sourceList = [];
        }
      });
    },
    getChannel() {
      this.$http
        .getChannel({
          channel_medianame: this.selectForm.frommedia_name,
        })
        .then((res) => {
          (() => {})(res);
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.selectForm.channelList = data.list;
          } else {
            this.selectForm.channelList = [];
          }
        });
    },
    // 招生有效名单表格数据
    getChannellogList() {
      channelRecordRequest
        .getChannellogList({
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          postbe_crmuserlevel: this.postbe_crmlevel,

          frommedia_name: this.selectForm.frommedia_name,
          frommedia_id: this.selectForm.frommedia_id,
          to_channel_id: this.selectForm.channel_id,
          channellog_status: this.selectForm.channellog_status,
          keyword: this.selectForm.keyword,
          start_time: this.selectForm.range_time
            ? this.selectForm.range_time[0]
            : "",
          end_time: this.selectForm.range_time
            ? this.selectForm.range_time[1]
            : "",
        })
        .then((res) => {
          const { data, msg } = res.data;
          this.tableData = data.list;
          this.dataNumber = parseInt(data.all_num);
          var Columns = data.field;
          this.allColumns = data.field;
          this.$Tool.setStorage("allColumns", this.allColumns);
          this.showColumn = JSON.parse(localStorage.getItem("showColumns"));
          var fieldColumns = data.field;
          if (JSON.parse(localStorage.getItem("showColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            -1
          );
          this.optionscaozuo.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom == 0,
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          this.optionscaozuo.errortip = msg;
          this.notreadnum = data.notreadnum;
        });
    },
    // 编辑列
    Changeoprate() {
      (() => {})(this.$t("views.Customersmanage.channelRecord.5zrpeqo9qzk0"));
    }, // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getChannellogList();
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getChannellogList();
    },

    // 获取单个客户的基本信息
    getclientOneData(id) {
      channelRecordRequest
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.UserInformation = res.data.data.list;
        });
    },

    //点击查看
    handleColumnChange(k, v) {
      this.activeName = "first";
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);
      this.showSliderBoxSee = true;
    },

    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    // 点击排序方式***功能菜单
    handleCommandSort(command) {
      (() => {})(command);
      this.selectForm.order = command;
      this.currentPage = 1;
      this.getChannellogList();
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showColumns", this.showColumns);
      this.settingVisible = false;
      this.getChannellogList();
      (() => {})(allnum);
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getChannellogList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getChannellogList();
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      if (val != "") {
        let timer = setTimeout(() => {
          this.buttonHide = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.buttonHide = false;
      }
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("channelRecord.less");
.show-img__mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000000;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.channelRecord {
  height: 100vh;
  font-size: 20px;
  .apply-channel__desc {
    display: flex;
    margin: 0 -20px;
    line-height: 35px;
    align-items: center;
    justify-content: center;
    color: rgba(32, 168, 216, 1);
    background-color: rgba(32, 168, 216, 0.14);
  }
  .apply-channel__notice {
    color: red;
  }
  .apply-user-pop {
    display: flex;
    padding: 20px;
    align-items: center;
    .user-info__img {
      width: 100px;
      padding-right: 13px;
      display: flex;
      justify-content: flex-end;
      img {
        display: block;
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }
    .user-info__name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      display: flex;
      align-items: center;
      .user-tips {
        margin-left: 20px;
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        font-style: normal;
        color: rgba(32, 168, 216, 1);
        border-radius: 5px;
        background-color: rgba(32, 168, 216, 0.05);
      }
    }
  }
  .choose-user-row {
    display: flex;
    padding: 0 20px;
    .tit {
      width: 100px;
    }

    .user-content {
      flex: 1;
      padding-top: 2px;
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
    }

    .user-content-item {
      margin: 0 30px 15px 0;
      position: relative;
      .el-icon-circle-close {
        top: -5px;
        right: -15px;
        position: absolute;
        color: red;
        cursor: pointer;
        &:hover {
          color: #20a8d8;
        }
      }
    }
  }

  .slider-channel-record {
    .user-header {
      display: flex;
      padding-top: 20px;
      align-items: flex-start;
      position: relative;
      .user-header__desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        .desc {
          display: flex;
          margin-bottom: 5px;
          align-items: center;
        }
        .desc-sex__img {
          margin: 0 15px 0 5px;
        }
        .tag-normal {
          padding: 0 5px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #20a8d8;
          line-height: 26px;
          border: 1px solid #20a8d8;
          border-radius: 3px;
        }
        .tag-status {
          padding: 0 6px;
          line-height: 26px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
        }
        .tag-red {
          background: #f35c5c;
        }
        .tag-blue {
          background: #20a8d8;
        }
        .tag-yellow {
          background: #f8cd09;
        }
      }
      .notice-tags {
        right: 20px;
        top: 20px;
        width: 98px;
        height: 98px;
        position: absolute;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          transform: rotate(-15deg);
          position: relative;
        }
        &.notice-success {
          color: #20a8d8;
          border: 1px solid #20a8d8;
        }
        &.notice-fail {
          color: #f35c5c;
          border: 1px solid #f35c5c;
        }
      }
      .user-header__img {
        margin-right: 10px;
      }
      td {
        width: 200px;
        line-height: 30px;
      }
    }

    .channel-apply-info {
      li {
        margin-bottom: 15px;
        font-size: 14px;
      }
      .tit {
        color: #aaa;
      }
      .desc {
        color: #666;
      }
    }
  }

  .channel-view__tabs {
    .el-tabs__nav {
      padding-left: 0;
    }
  }
  .slider-channel-record {
    .el-row .grid-content-img img {
      height: 100%;
    }
    .slider-studentBind .el-row .el-col {
      min-height: 178px;
    }
    .el-row .grid-content > p {
      height: auto;
    }
    .el-row .grid-content .communite-cont {
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      p {
        flex: 1;
      }
      .btns {
        width: 135px;
        margin-left: 10px;
        .el-button {
          width: 60px;
        }
        .btn-disabled {
          background-color: #cccccc;
          border-color: #cccccc;
        }
      }
    }
    .el-row .grid-content .communite-replay {
      display: flex;
      border-top: 1px dashed #ddd;
      .replay-cont {
        flex: 1;
        line-height: 24px;
      }
      .img {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .replay-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .channel-history {
    margin: 0 0 0 10px;
    padding-bottom: 10px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 10px;
      width: 1px;
      height: 100%;
      background-color: rgba(40, 171, 217, 1);
      border-radius: 50%;
    }
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      margin-bottom: 20px;
    }
    .channel-history__title {
      margin: 0 0 10px 0;
      padding-left: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a4a4a4;
      line-height: 20px;
      letter-spacing: 1px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -5px;
        top: 5px;
        width: 6px;
        height: 6px;
        padding: 2px;
        border: 1px solid rgba(0, 173, 223, 1);
        background-color: rgba(0, 173, 223, 1);
        background-clip: content-box;
        border-radius: 50%;
      }
    }
    .channel-history-box {
      width: 96%;
      margin: 0 auto;
      padding: 20px 30px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
      .channel-row {
        display: flex;
        align-items: flex-start;
        .channel-detail {
          display: flex;
          flex: 5;
          padding: 16px 0;
          align-items: center;
          justify-content: space-around;
          background-color: rgba(32, 168, 216, 0.05);
          .channel-detail__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #3a3a3a;
            line-height: 19px;
            letter-spacing: 1px;
            p {
              margin-top: 20px;
              &:first-child {
               margin-top: 0;
              }
            }
          }
          .channel-detail__tips {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 47px;
              height: 25px;
            }
            p {
              font-size: 12px;
              font-family: MicrosoftYaHei;
              color: #aaaaaa;
              line-height: 16px;
              letter-spacing: 1px;
            }
          }
        }
        .channel-status {
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .dot {
            width: 6px;
            height: 6px;
            margin-right: 5px;
            border-radius: 50%;
          }
          &.status-success {
            color: rgba(32, 168, 216, 1);
            .dot {
              background-color: rgba(32, 168, 216, 1);
            }
          }
          &.status-fail {
            color: rgba(243, 92, 92, 1);
            .dot {
              background-color: rgba(243, 92, 92, 1);
            }
          }
          &.status-wait {
            color: rgba(6, 217, 3, 1);
            .dot {
              background-color: rgba(6, 217, 3, 1);
            }
          }
          &.status-warn {
            color: rgba(255, 203, 0, 1);
            .dot {
              background-color: rgba(255, 203, 0, 1);
            }
          }
        }
      }
    }
    .channel-history__teacher {
      margin-top: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #55606e;
      line-height: 19px;
      letter-spacing: 1px;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  .tab-num-tips {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -8px;
    font-size: 13px;
    color: #fff;
    line-height: 100%;
    font-style: normal;
    text-align: center;
    line-height: 16px;
    vertical-align: top;
    background-color: red;
    border-radius: 50%;
  }
}
#viewerStyle {
  .el-image-viewer__wrapper {
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0px;
    left: 0px;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
  .el-image-viewer__btn {
    color: #777;
  }
  .el-image-viewer__close {
    position: absolute;
    right: 0;
    z-index: 20000000;
  }
  .el-image-viewer__prev {
    position: absolute;
    top: 50%;
    left: 5%;
    z-index: 20000000;
  }
  .el-image-viewer__next {
    position: absolute;
    top: 50%;
    right: 5%;
    z-index: 20000000;
  }
  .el-icon-arrow-left {
    font-size: 80px;
  }
  .el-icon-arrow-right {
    font-size: 80px;
  }
  .el-icon-circle-close {
    font-size: 40px;
  }
  .el-icon-zoom-out {
    font-size: 40px;
  }
  .el-icon-zoom-in {
    font-size: 40px;
  }
  .el-icon-full-screen {
    font-size: 40px;
  }
  .el-icon-refresh-left {
    font-size: 40px;
  }
  .el-icon-refresh-right {
    font-size: 40px;
  }
  .el-icon-arrow-left:hover,
  .el-icon-arrow-right:hover,
  .el-icon-circle-close:hover,
  .el-icon-zoom-out:hover,
  .el-icon-zoom-in:hover,
  .el-icon-full-screen:hover,
  .el-icon-refresh-left:hover,
  .el-icon-refresh-right:hover {
    cursor: pointer;
  }
  .el-image-viewer__actions__inner {
    position: absolute;
    left: 50%;
    bottom: 5%;
    z-index: 20000000;
    background-color: #888;
  }
  .el-image-viewer__canvas img {
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
